import { absoluteUtc, relative } from '../format'

/*
 * `DESIGN_SYSTEM.md` §7.18's as-of stamp, on the one page where it is the whole
 * argument: a status page without a timestamp is a claim with no expiry, and
 * "all systems operational" from forty minutes ago is the exact sentence §5.3
 * exists to prevent.
 *
 * ── Absolute UTC beside relative, not instead of it ─────────────────────────
 *
 * §7.17: relative times are "only ever supplementary; the absolute instant is
 * always present". An incident is reconstructed across timezones by people
 * comparing logs, and "2 minutes ago" is unusable for that the moment the tab
 * has been open a while. UTC is rendered rather than local because this page is
 * read alongside server logs, which are in UTC.
 *
 * ── Stale says so, in words ────────────────────────────────────────────────
 *
 * §7.18: "a stale panel shows the bar in `--caution` and the word 'stale'". Here
 * the stale condition has already demoted every state to `unknown` upstream
 * (`use-status.ts`), so this line explains a change the reader has already seen
 * rather than being the only sign of it.
 */

export function UpdatedAt({
  isoInstant,
  stale,
}: {
  readonly isoInstant: string
  readonly stale: boolean
}) {
  const relativeText = relative(isoInstant)
  return (
    <p className="mt-8 text-xs text-text-muted">
      <span>Last updated </span>
      <time dateTime={isoInstant} className="type-data">
        {absoluteUtc(isoInstant)}
      </time>
      {relativeText === null ? null : <span> · {relativeText}</span>}
      {stale ? (
        <span className="text-caution">
          {' '}
          · stale — this page has not received an update from the platform
        </span>
      ) : null}
    </p>
  )
}
